import $axios from "../../api";

const PREFIX = "website/expedition-method";

const state = {
  isLoading: false,
  createLoading: false,
  errors: null,
  isSuccess: false,
  list: [],
  page: 1,
  detail: null,
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_CREATE_LOAD(state, payload) {
    state.createLoading = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  CLEAR_DETAIL(state) {
    state.detail = null;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return $axios
      .get(
        `${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
      )
      .then((res) => {
        commit("SET_LIST", res.data.data);
      })
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      )
      .finally(() => commit("SET_LOADING", false));
  },

  getDetail({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("CLEAR_DETAIL");
    return $axios
      .get(`${PREFIX}/view/${id}`)
      .then((res) => commit("SET_DETAIL", res.data.data))
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      )
      .finally(() => commit("SET_LOADING", false));
  },

  updateDefault({ commit, dispatch }, { id, payload }) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);
    commit("SET_ERRORS", null);
    return $axios
      .put(`${PREFIX}/update-default/${id}`, payload)
      .then((res) => {
        commit("SET_SUCCESS", true);
        dispatch("Main/globalSuccessSweetAlert", res.data.message, {
          root: true,
        });
      })
      .catch((err) => {
        commit("SET_ERRORS", err.response?.data?.errors || null);
        dispatch("Main/globalSweetAlert", err.response, { root: true });
      })
      .finally(() => commit("SET_CREATE_LOAD", false));
  },

  showHide({ commit, dispatch }, id) {
    commit("SET_SUCCESS", false);
    return $axios
      .put(`${PREFIX}/showhide/${id}`)
      .then((res) => {
        commit("SET_SUCCESS", true);
        dispatch("Main/globalSuccessSweetAlert", res.data.message, {
          root: true,
        });
      })
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  toggleRecommendation({ commit, dispatch }, id) {
    commit("SET_SUCCESS", false);
    return $axios
      .put(`${PREFIX}/recommendation/${id}`)
      .then((res) => {
        commit("SET_SUCCESS", true);
        dispatch("Main/globalSuccessSweetAlert", res.data.message, {
          root: true,
        });
      })
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  changePosition({ commit, dispatch }, { id, num_index }) {
    commit("SET_SUCCESS", false);
    return $axios
      .put(`${PREFIX}/change-position/${id}`, { num_index })
      .then(() => commit("SET_SUCCESS", true))
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  createSchedule({ commit, dispatch }, { id, payload }) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);
    commit("SET_ERRORS", null);
    return $axios
      .post(`${PREFIX}/schedule/${id}`, payload)
      .then((res) => {
        commit("SET_SUCCESS", true);
        dispatch("Main/globalSuccessSweetAlert", res.data.message, {
          root: true,
        });
      })
      .catch((err) => {
        commit("SET_ERRORS", err.response?.data?.errors || null);
        dispatch("Main/globalSweetAlert", err.response, { root: true });
      })
      .finally(() => commit("SET_CREATE_LOAD", false));
  },

  deleteSchedule({ commit, dispatch }, { id, scheduleId }) {
    commit("SET_SUCCESS", false);
    return $axios
      .delete(`${PREFIX}/schedule/${id}/${scheduleId}`)
      .then((res) => {
        commit("SET_SUCCESS", true);
        dispatch("Main/globalSuccessSweetAlert", res.data.message, {
          root: true,
        });
      })
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
